module.exports = __webpack_public_path__ + "media/gifts/gift-pico-rejuvenation-treatment-15c4a606.png";